import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import * as newClientActions from './new-client.actions';
import * as clientsActions from '../../client-list/store/clients.actions';
import { withLatestFrom, switchMap, mergeMap, map, catchError, tap, concatMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { NewClientSelectors, ScookieService, NewClientService } from '@store';
import { AlertService } from 'app/core/alerts/alert.service';

@Injectable()
export class NewClientEffects {

     storeNewClientData$ = createEffect(() => this.actions$.pipe(
        ofType<newClientActions.StoreNewClientData>(newClientActions.STORE_NEW_CLIENT_DATA),
        withLatestFrom(this.newClientSelector.newClientData$),
        mergeMap(([, newClientData]) => {
            const clientData = {
                ...newClientData
            };
            return this.scookieService.saveCookieUnique('newClientData', JSON.stringify(clientData));
        })
    ), {dispatch: false});

     loadNewClientData$ = createEffect(() => this.actions$.pipe(
        ofType(newClientActions.LOAD_NEW_CLIENT_DATA),
        mergeMap(() => {
            return this.scookieService.getCookie('newClientData', 1).pipe(
                map(newClientData =>
                    new newClientActions.LoadNewClientDataSuccess(newClientData)
                )
            );
        })
    ));

     setNewClientBasic$ = createEffect(() => this.actions$.pipe(
        ofType(newClientActions.SET_NEW_CLIENT_BASIC),
        map(() => new newClientActions.StoreNewClientData())
    ));


     storeNewClientRelation$ = createEffect(() => this.actions$.pipe(
        ofType(newClientActions.STORE_NEW_CLIENT_RELATION),
        map(() => new newClientActions.StoreNewClientData())
    ));

     saveNewClientData$ = createEffect(() => this.actions$.pipe(
        ofType(newClientActions.SAVE_NEW_CLIENT_DATA),
        withLatestFrom(this.newClientSelector.newClientData$),
        switchMap(([, newClientData]) => {
            const clientData = {
                ...newClientData
            };
            return this.newClientService.createNewClient(clientData).pipe(
                concatMap(createdClientData => {
                    return [
                        new newClientActions.SaveNewClientDataSuccess(),
                        new clientsActions.AddClient(createdClientData)
                    ];
                }),
                catchError(() => of(new newClientActions.SaveNewClientDataFailed()))
            );
        })
    ));

     resetNewClientData$ = createEffect(() => this.actions$.pipe(
        ofType(newClientActions.RESET_NEW_CLIENT_DATA),
        map(() => new newClientActions.ResetDone())
    ));

     resetDone$ = createEffect(() => this.actions$.pipe(
        ofType(newClientActions.RESET_DONE),
        map(() => new newClientActions.StoreNewClientData())
    ));

     saveNewClientDataFailed$ = createEffect(() => this.actions$.pipe(
        ofType(newClientActions.SAVE_NEW_CLIENT_DATA_FAILED),
        tap(() => this.alert.createAlert('Oprettelse fejlede!', 'danger'))
    ), {dispatch: false});

    constructor(
        private actions$: Actions,
        private newClientSelector: NewClientSelectors,
        private scookieService: ScookieService,
        private newClientService: NewClientService,
        private alert: AlertService
    ) {}

}
